import { DomainEvent } from "./DomainEvent";

export class OfferResponseEvent extends DomainEvent {
    static eventType = 'offer_response';

    #userId;
    #productId;
    #offerId;
    #response;
    #message;
    #buyerId;

    constructor(userId, productId, offerId, response, message, buyerId) {
        super(OfferResponseEvent.eventType);

        this.#userId = userId;
        this.#productId = productId;
        this.#offerId = offerId;
        this.#response = response;
        this.#message = message;
        this.#buyerId = buyerId;
    }

    get userId() {
        return this.#userId;
    }

    get productId() {
        return this.#productId;
    }

    get offerId() {
        return this.#offerId;
    }

    get response() {
        return this.#response;
    }

    get message() {
        return this.#message;
    }

    get buyerId() {
        return this.#buyerId;
    }

}